import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { IOrder } from '../../../../Models/Order/IOrder';
import { IOrderListItem } from '../../../../Models/Order/IOrderListItem';
import { OrderListAdminView } from './OrderListAdminView';
import * as Services from '../../../../Services/Services';
import { IOrderApi } from '../../../../Services/API/Order/IOrderApi';
import { MessageBarType } from '@fluentui/react';
import { OrderDetail } from '../../../Orders/OrderDetail/OrderDetail';
import { OrderListAdminFilterViewPage } from './OrderListAdminFilterView';
import { IOrderListFilter } from '../../../../Models/Order/IOrderListFilter';
import { debounce } from '../../../../Tools/trottle'

interface IOrderListAdminProps {

}


export const OrderListAdmin: React.FunctionComponent<IOrderListAdminProps> = (props) => {
    const [orderItemList, setOrderItemList] = React.useState<IOrderListItem[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isPropertiesOpened, setIsPropertiesOpened] = useBoolean(false);
    const [selectedOrder, setSelectedOrder] = React.useState<IOrder>();
    const [filter, setFilter] = React.useState<IOrderListFilter>({});

    const selectOrder = (item: IOrderListItem) => {
        loadEvent(item.id);
    }

    const loadData = async (filter: IOrderListFilter) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const orderApi = Services.ServicesProvider.GetService<IOrderApi>(Services.OrderApi);
        const orders = await orderApi.getOrdersList(filter.orderId, filter.state, filter.name, filter.eventName, filter.onlyUnfinished);

        if (orders.isSuccess && orders.data) {
            setStatusMessage(undefined);
            setOrderItemList(orders.data);
        }
        else {
            setStatusMessage({ message: orders.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }


    const delayedQuery = React.useCallback(debounce((f: IOrderListFilter) => { loadData(f) },300 ), []);

    React.useEffect(() => {
        delayedQuery(filter);
    }, [filter]);  

    const loadEvent = async (id: number) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IOrderApi>(Services.OrderApi);
        const result = await eventTypeApi.getOrder(id);
        if (result.isSuccess && result.data) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            setSelectedOrder(result.data);
            setIsPropertiesOpened.setTrue();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const refresh = () => {

    }

    const filterPropertyChanged = (key: string, value: string | boolean | undefined) => {
        setFilter({ ...filter, [key]: value });
    }

    return (<>

        <OrderListAdminView filter={filter} filterPropertyChanged={filterPropertyChanged} items={orderItemList} isLoading={isLoading} selectItem={selectOrder} />
        {selectedOrder ?
            <OrderDetail orderId={selectedOrder.id}
                isOpen={isPropertiesOpened}
                close={setIsPropertiesOpened.setFalse}
                refresh={refresh}
                isAdmin={true}
            /> : null}
        </>
    );
}

